import { useEffect, useState } from "react";
import { Mail } from "lucide-react";
import { api } from "../lib/api";
import { renderInline } from "../lib/richText";
import { ContactForm } from "../components/ContactForm";
import { Eyebrow, WreathWatermark } from "../components/Botanical";

const INTRO = [
  "We're Carla and Brittney, the two moms behind Kind Of Crunchy Moms.",
  "What started as two women who weren't even sure they liked each other turned into a friendship neither could imagine living without.",
  "That friendship became the heart of KOCM.",
  "We're a small, independently owned business that believes in personal customer service, clear communication, and treating our customers with care.",
  "We're grateful for everyone who supports our little business and the friendship that started it all.",
];

export default function Contact() {
  const [info, setInfo] = useState(null);
  useEffect(() => {
    api.get("/policies/contact").then((r) => setInfo(r.data)).catch(() => setInfo({ title: "Contact Us", body_md: "" }));
  }, []);

  return (
    <div className="relative overflow-x-clip" data-testid="contact-page">
      <div className="relative max-w-3xl mx-auto px-6 py-16 sm:py-20">
        <Eyebrow>Get in touch</Eyebrow>
        <h1 className="font-serif text-4xl sm:text-5xl mt-2" data-testid="contact-heading">{info?.title || "Contact Us"}</h1>

        <section className="relative overflow-hidden mt-10 rounded-2xl bg-[#C99898]/10 border border-[#C99898]/40 p-6 sm:p-10" data-testid="contact-intro">
          <WreathWatermark />
          <h2 className="relative font-serif text-2xl sm:text-3xl text-[#5A433B]">A Little About KOCM</h2>
          <div className="relative mt-4 space-y-3 text-base text-[#5E4D5A] leading-relaxed">
            {INTRO.map((p) => <p key={p}>{p}</p>)}
          </div>
          <p className="relative font-signature text-5xl text-[#5A433B] leading-none mt-6 -rotate-2 origin-left" data-testid="contact-signature">Carla &amp; Brittney</p>
          <p className="mt-2 text-xs uppercase tracking-[0.25em] text-[#5E6B51]">Co-Founders, Kind Of Crunchy Moms</p>
        </section>

        <section className="mt-12" data-testid="contact-info">
          <h2 className="font-serif text-3xl text-[#5A433B]">Contact Information</h2>
          <div className="mt-4 flex gap-3 items-start text-[#5E4D5A] leading-relaxed">
            <Mail size={18} className="mt-1 text-[#5E6B51] shrink-0" />
            <div className="space-y-2">
              {(info?.body_md || "").split(/\n+/).filter(Boolean).map((p, i) => <p key={i}>{renderInline(p)}</p>)}
            </div>
          </div>
        </section>

        <section className="mt-10">
          <h2 className="font-serif text-2xl text-[#5A433B] mb-4">Send us a message</h2>
          <ContactForm />
        </section>
      </div>
    </div>
  );
}
